var map = {
	"./registration.png": 8687,
	"./start_1.png": 6317,
	"./start_2.png": 8827,
	"./start_3.png": 8163,
	"./target_default_1.png": 2101,
	"./target_default_2.png": 3782,
	"./target_default_3.png": 7560,
	"./target_detail_default_1.png": 1479,
	"./workout_default_1.png": 8638,
	"./workout_default_2.png": 3979,
	"./workout_default_3.png": 4718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1467;